// extracted by mini-css-extract-plugin
export var childrenContainer = "_bg-0";